module.exports = __webpack_public_path__ + "img/depmap_svg_V84.1fd43348.svg";